import React, { memo } from 'react';
import { size, findIndex } from 'lodash';
import styled from 'styled-components/macro';
import i18n from 'i18n';
import scaleSize from 'utils/scale-size';
import VerticalList from 'components/VerticalList';
import { StyledEpgItemWrapper, StyledCategoryItem } from './StyledComponents';
import getLocalized from 'utils/get-localized';

const CONFIG = {
  enterTo: 'last-focused',
  leaveFor: {
    up: '',
    down: '',
  },
};

export const StyledListWrapper = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  display: inline-block;
`;

export const StyledListTitle = styled.div`
  height: ${scaleSize(68)}px;
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(48)}px;
  margin-left: ${scaleSize(20)}px;
  letter-spacing: -0.277778px;
  color: #ffffff;
`;

export const StyledCategoriesList = styled(VerticalList)`
  width: ${scaleSize(910)}px;
  height: ${scaleSize(1080)}px;
  margin-top: ${scaleSize(13)}px;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
`;

export const StyledTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(40)}px;
  line-height: ${scaleSize(48)}px;
  letter-spacing: -0.277778px;
  color: ${({ isActive, theme }) => (isActive ? theme.activeColor : theme.defaultColor)};
`;

export const StyledDescription = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(40)}px;
  letter-spacing: -0.236111px;
  color: ${({ theme }) => theme.iconDefaultColor};
`;

const CategoryItem = memo(({ id, onEnter, onFocus, item, isActive, index }) => {
  const { name, names, channelIds } = item;
  const categoryName = getLocalized(names, name);
  const channelsSize = size(channelIds);
  return (
    <StyledEpgItemWrapper id={id} onEnter={() => onEnter(index)} onFocus={onFocus} index={index} type={'category'}>
      <StyledCategoryItem>
        <StyledTitle isActive={isActive}>{categoryName}</StyledTitle>
        <StyledDescription>{i18n.t('epg.categories.channel', { count: channelsSize })}</StyledDescription>
      </StyledCategoryItem>
    </StyledEpgItemWrapper>
  );
});

export const CategoriesList = (props) => {
  const { sectionName, activeCategoryId, content = [], isVisible } = props;
  const { onFocus, onEnter, onListFocus } = props;

  const defaultIndex = findIndex(content, { id: activeCategoryId });
  return (
    <StyledListWrapper isVisible={isVisible}>
      <StyledListTitle>{i18n.t('epg.categories.title')}</StyledListTitle>
      <StyledCategoriesList
        listId={'categories-list-wrapper'}
        sectionName={sectionName}
        items={content}
        itemComponent={CategoryItem}
        defaultIndex={defaultIndex >= 0 ? defaultIndex : 0}
        itemHeight={180}
        onFocus={onFocus}
        onEnter={onEnter}
        onListFocus={onListFocus}
        config={CONFIG}
        renderSize={5}
        infinite
      />
    </StyledListWrapper>
  );
};

export default CategoriesList;
